import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=2e95b9c7&"
import script from "./wysiwyg.vue?vue&type=script&lang=js&"
export * from "./wysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports